
import React, {  useState, useEffect } from "react";
import logo from "../assets/imgs/logo.png";
import  { Link, useLocation } from "react-router-dom";
import stock from "../assets/svgs/stock_manag.svg";
import helpcenter from "../assets/svgs/helpcenter.svg";
import setting_icon from "../assets/svgs/setting.svg";
import user_manag_icon from "../assets/svgs/user_manag.svg";
import dashboard_icon from "../assets/svgs/dashboard.svg";
import price_manag_icon from "../assets/svgs/price_manag.svg";
import eclipse_green from "../assets/svgs/eclipse_green.svg";
import eclipse from "../assets/svgs/eclipse.svg";
import chevron_bottom from "../assets/svgs/chevron_bottom.svg";
import { useSelector } from "react-redux";

const SideBar = ({ sidebar }) => {
  const [toggleMenu, setToggleMenu] = useState(true);
  const [activeLink, setActiveLink] = useState("dashboard");

  const stateUser = useSelector((state) => state?.auth?.user); 

  const handleToggleMenu = () => {
      setToggleMenu(!toggleMenu);
  }
 
  const pathname = useLocation();
 
 
  useEffect(() => {
    // Update the active link whenever the route changes
    if (pathname.pathname === "/dashboard") {
      setActiveLink("dashboard");
    } else if (pathname.pathname === "/dashboard/user-management/admin") {
      setActiveLink("admin");
    } else if (pathname.pathname === "/dashboard/user-management/member") {
      setActiveLink("member");
    } else if (pathname.pathname === "/dashboard/price-management") {
      setActiveLink("price-management");
    } else if (pathname.pathname === "/dashboard/stock-management") {
      setActiveLink("stock-management");
    } else if (pathname.pathname === "/dashboard/help-center") {
      setActiveLink("help-center");
    } else if (pathname.pathname === "/dashboard/settings") {
      setActiveLink("settings");
    }
  }, [pathname])
  

  return (
    <nav className={`bg-secondary-n-10  ${sidebar ? "sidebar-hide" : "sidebar-show"} h-screen  drop-shadow-lg sticky top-0 left-0`}>
      <div className="border-b-[1px] border-b-secondary-n-40 py-[2px]">
        <img src={logo} height={79} width={289} alt="logo" />
      </div>
      
      <div className="py-8">
        <ul className="space-y-2">
          <li className={`${activeLink === 'dashboard' ? 'border-r-4 border-r-primary-yellow-500 bg-secondary-yellow-50' : 'hover:border-r-4 hover:border-r-primary-yellow-500 hover:bg-secondary-yellow-50'}`}>
            <Link to={"/dashboard"} className="flex items-center gap-3 px-3 py-1">
            <img src={dashboard_icon} alt={"dashboard icon"} />
            <span className="text-regular text-secondary-n-200">
            Dashboard
            </span>
            </Link>
          </li>

          <li className={``} onClick={handleToggleMenu}>
            <div className="flex items-center justify-between px-3 py-1">
            <div className="flex items-center gap-3">
            <img src={dashboard_icon} alt={"dashboard icon"} />
            <span className="text-regular text-secondary-n-200 cursor-pointer">
              User Management
            </span>
            </div>
            <img src={chevron_bottom} alt="chevron down icon" />
            </div>
            <div className={`${toggleMenu ? "transition-hide" : "transition-show"}`}>
            <ul className="space-y-2 py-2">
        { stateUser?.auth === "ROLE_SUPER_ADMIN" ? (
           <li className={`px-8 ${activeLink === 'admin' ? 'border-r-4 border-r-primary-yellow-500 bg-secondary-yellow-50' : 'hover:border-r-4 hover:border-r-primary-yellow-500 hover:bg-secondary-yellow-50'}`}>
           <Link to={"/dashboard/user-management/admin"} className="flex items-center gap-3 px-3 py-1">
           <img src={eclipse} alt="rounded icon" />
           <span className="text-regular text-secondary-n-200">
            Admin
           </span>
           </Link>
         </li>
        ) : (
          <></>
        ) }
          <li className={`px-8 ${activeLink === 'member' ? 'border-r-4 border-r-primary-yellow-500 bg-secondary-yellow-50' : 'hover:border-r-4 hover:border-r-primary-yellow-500 hover:bg-secondary-yellow-50'}`}>
           <Link to={"/dashboard/user-management/member"} className="flex items-center gap-3 px-3 py-1">
           <img src={eclipse} alt="rounded icon" />
           <span className="text-regular text-secondary-n-200">
            Member
           </span>
           </Link>
         </li>
        </ul>
            </div>
          </li>

          <li className={`${activeLink === 'price-management' ? 'border-r-4 border-r-primary-yellow-500 bg-secondary-yellow-50' : 'hover:border-r-4 hover:border-r-primary-yellow-500 hover:bg-secondary-yellow-50'}`}>
            <Link to={"/dashboard/price-management"} className="flex items-center gap-3 px-3 py-1">
            <img src={price_manag_icon} alt="price icon" />
            <span className="text-regular text-secondary-n-200">
            Price Management
            </span>
            </Link>
          </li>

          <li className={`${activeLink === 'stock-management' ? 'border-r-4 border-r-primary-yellow-500 bg-secondary-yellow-50' : 'hover:border-r-4 hover:border-r-primary-yellow-500 hover:bg-secondary-yellow-50'}`}>
            <Link to={"/dashboard/stock-management"} className="flex items-center gap-3 px-3 py-1">
            <img src={stock} alt="stock" />
            <span className="text-regular text-secondary-n-200">
            Stock Management
            </span>
            </Link>
          </li>

          <li className={`${activeLink === 'help-center' ? 'border-r-4 border-r-primary-yellow-500 bg-secondary-yellow-50' : 'hover:border-r-4 hover:border-r-primary-yellow-500 hover:bg-secondary-yellow-50'}`}>
            <Link to={"/dashboard/help-center"} className="flex items-center gap-3 px-3 py-1">
            <img src={helpcenter} alt="helpcenter" />
            <span className="text-regular text-secondary-n-200">
            Help Center
            </span>
            </Link>
          </li>

          <li className={`${activeLink === 'settings' ? 'border-r-4 border-r-primary-yellow-500 bg-secondary-yellow-50' : 'hover:border-r-4 hover:border-r-primary-yellow-500 hover:bg-secondary-yellow-50'}`}>
            <Link to={"/dashboard/settings"} className="flex items-center gap-3 px-3 py-1">
            <img src={setting_icon} alt="setting" />
            <span className="text-regular text-secondary-n-200">
              Settings
            </span>
            </Link>
          </li>
        </ul>
      </div>
    </nav>
  );
};

export default SideBar;
